import type { ITipPort } from '@onboarding/application/ports';
import { DEFAULT_TIP_PERCENT_OPTIONS } from '@onboarding/domain/value-objects';
import type { TipConfig } from '@onboarding/domain/value-objects';
import type { OnboardingHttpClientType } from '@onboarding/infrastructure/api';

/**
 * Concrete implementation of ITipPort.
 * Writes the initial pay terminal configuration for a new store during onboarding.
 * Sends the minimal body accepted by the backend — no GET needed since this is
 * the first configuration for the store.
 */
export const createTipRepository = (props: { httpClient: OnboardingHttpClientType }): ITipPort => {
  const { httpClient } = props;

  const applyPayConfig = async (config: TipConfig): Promise<void> => {
    await httpClient.updatePayConfig({
      isTippingEnabled: config.enabled,
      tipPercentOptions: [...DEFAULT_TIP_PERCENT_OPTIONS],
      shouldAutomaticallyCloseOrder: false,
      isFeedbackEnabled: false,
    });
  };

  return { applyPayConfig };
};
